{
  "writers": {
    "src": "/use-case-films/writers.mp4",
    "poster": "/use-case-films/writers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/writers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for writers & bloggers, featuring Content Generator, Text Humanizer, AI Content Detector and an illustrative tool preview."
  },
  "marketers": {
    "src": "/use-case-films/marketers.mp4",
    "poster": "/use-case-films/marketers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/marketers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for marketing teams, featuring Image Generator, Video Generator, Social Media Writer and an illustrative tool preview."
  },
  "developers": {
    "src": "/use-case-films/developers.mp4",
    "poster": "/use-case-films/developers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/developers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for software engineers, featuring Code Assistant, API Access, Multi-Model Compare and an illustrative tool preview."
  },
  "photographers": {
    "src": "/use-case-films/photographers.mp4",
    "poster": "/use-case-films/photographers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/photographers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for photographers, featuring AI Photo Editor, Background Remover, Headshot Generator and an illustrative tool preview."
  },
  "content-creators": {
    "src": "/use-case-films/content-creators.mp4",
    "poster": "/use-case-films/content-creators.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/content-creators.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for content creators, featuring Thumbnail Generator, Video Generator, Music Generator and an illustrative tool preview."
  },
  "designers": {
    "src": "/use-case-films/designers.mp4",
    "poster": "/use-case-films/designers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/designers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for graphic designers, featuring Image Generator, Logo Generator, Image Editor and an illustrative tool preview."
  },
  "musicians": {
    "src": "/use-case-films/musicians.mp4",
    "poster": "/use-case-films/musicians.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/musicians.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for musicians & producers, featuring Music Generator, Lyrics Writer, Cover Art Generator and an illustrative tool preview."
  },
  "students": {
    "src": "/use-case-films/students.mp4",
    "poster": "/use-case-films/students.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/students.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for students & researchers, featuring Document Analysis, Deep Research, Reasoning Models and an illustrative tool preview."
  },
  "small-business": {
    "src": "/use-case-films/small-business.mp4",
    "poster": "/use-case-films/small-business.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/small-business.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for small businesses, featuring Logo Generator, Marketing Graphics, Copywriting and an illustrative tool preview."
  },
  "real-estate": {
    "src": "/use-case-films/real-estate.mp4",
    "poster": "/use-case-films/real-estate.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/real-estate.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for real estate agents, featuring Listing Writer, Virtual Staging, Marketing Graphics and an illustrative tool preview."
  },
  "ecommerce": {
    "src": "/use-case-films/ecommerce.mp4",
    "poster": "/use-case-films/ecommerce.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/ecommerce.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for e-commerce sellers, featuring Background Remover, Product Image Generator, Description Writer and an illustrative tool preview."
  },
  "free-thinkers": {
    "src": "/use-case-films/free-thinkers.mp4",
    "poster": "/use-case-films/free-thinkers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/free-thinkers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for free thinkers, featuring Uncensored Chat, Unbiased Research, Private by Design and an illustrative tool preview."
  },
  "independent-media": {
    "src": "/use-case-films/independent-media.mp4",
    "poster": "/use-case-films/independent-media.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/independent-media.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for independent media, featuring Deep Research, Article Writer, Transcription and an illustrative tool preview."
  },
  "teachers": {
    "src": "/use-case-films/teachers.mp4",
    "poster": "/use-case-films/teachers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/teachers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for teachers & educators, featuring Lesson Plan Generator, Worksheet & Quiz Maker, Differentiation and an illustrative tool preview."
  },
  "homeschoolers": {
    "src": "/use-case-films/homeschoolers.mp4",
    "poster": "/use-case-films/homeschoolers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/homeschoolers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for homeschool families, featuring Year & Week Planner, Unit Study Builder, Multi-age Lessons and an illustrative tool preview."
  },
  "sales": {
    "src": "/use-case-films/sales.mp4",
    "poster": "/use-case-films/sales.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/sales.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for sales teams, featuring Cold Email Writer, Prospect Research, Follow-Up Sequences and an illustrative tool preview."
  },
  "coaches": {
    "src": "/use-case-films/coaches.mp4",
    "poster": "/use-case-films/coaches.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/coaches.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for coaches & consultants, featuring Program Builder, Worksheet & Workbook Maker, Social Content and an illustrative tool preview."
  },
  "nonprofits": {
    "src": "/use-case-films/nonprofits.mp4",
    "poster": "/use-case-films/nonprofits.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/nonprofits.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for nonprofits, featuring Grant Proposal Writer, Donor Appeals, Newsletter Writer and an illustrative tool preview."
  },
  "podcasters": {
    "src": "/use-case-films/podcasters.mp4",
    "poster": "/use-case-films/podcasters.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/podcasters.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for podcasters, featuring Transcription, Show Notes & Chapters, Clip & Quote Finder and an illustrative tool preview."
  },
  "freelancers": {
    "src": "/use-case-films/freelancers.mp4",
    "poster": "/use-case-films/freelancers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/freelancers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for freelancers, featuring Proposal Writer, Client Communication, Content & Copywriting and an illustrative tool preview."
  },
  "product-managers": {
    "src": "/use-case-films/product-managers.mp4",
    "poster": "/use-case-films/product-managers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/product-managers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for product managers, featuring PRD & Spec Writer, Feedback Synthesizer, Launch Comms and an illustrative tool preview."
  },
  "game-developers": {
    "src": "/use-case-films/game-developers.mp4",
    "poster": "/use-case-films/game-developers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/game-developers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for game developers, featuring Concept & Asset Art, 3D & Texture References, Music & Loops and an illustrative tool preview."
  },
  "filmmakers": {
    "src": "/use-case-films/filmmakers.mp4",
    "poster": "/use-case-films/filmmakers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/filmmakers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for filmmakers, featuring Treatment & Script, Key Art & Mood Boards, Mood Reels & Promo and an illustrative tool preview."
  },
  "agencies": {
    "src": "/use-case-films/agencies.mp4",
    "poster": "/use-case-films/agencies.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/agencies.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for creative agencies, featuring Copy & Campaigns, Creative & Branding, Video & Motion and an illustrative tool preview."
  },
  "authors": {
    "src": "/use-case-films/authors.mp4",
    "poster": "/use-case-films/authors.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/authors.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for authors & novelists, featuring Plot & Outline Builder, Character Development, Drafting & Editing and an illustrative tool preview."
  },
  "researchers": {
    "src": "/use-case-films/researchers.mp4",
    "poster": "/use-case-films/researchers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/researchers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for researchers & analysts, featuring Deep Research, Paper & Report Analysis, Literature Reviews and an illustrative tool preview."
  },
  "youtubers": {
    "src": "/use-case-films/youtubers.mp4",
    "poster": "/use-case-films/youtubers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/youtubers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for youtubers, featuring Thumbnail Generator, Scripts & Hooks, Shorts & Clips and an illustrative tool preview."
  },
  "social-media-managers": {
    "src": "/use-case-films/social-media-managers.mp4",
    "poster": "/use-case-films/social-media-managers.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/social-media-managers.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for social media managers, featuring Caption & Post Writer, Content Calendar, Social Graphics and an illustrative tool preview."
  },
  "architects": {
    "src": "/use-case-films/architects.mp4",
    "poster": "/use-case-films/architects.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/architects.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for architects, featuring Concept Visuals, Feasibility & Briefs, Interior & Staging Concepts and an illustrative tool preview."
  },
  "health-educators": {
    "src": "/use-case-films/health-educators.mp4",
    "poster": "/use-case-films/health-educators.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/health-educators.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for health educators, featuring Patient Handouts, Reading-Level Adaptation, Translation and an illustrative tool preview."
  },
  "veterans": {
    "src": "/use-case-films/veterans.mp4",
    "poster": "/use-case-films/veterans.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/veterans.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for veterans, featuring Skills Translator, Career Research, Benefits & Web Research and an illustrative tool preview."
  },
  "recipes-cooking": {
    "src": "/use-case-films/recipes-cooking.mp4",
    "poster": "/use-case-films/recipes-cooking.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/recipes-cooking.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for recipes & cooking, featuring Meal Planner, Recipe Generator, Nutrition & Macros and an illustrative tool preview."
  },
  "travel-and-exploration": {
    "src": "/use-case-films/travel-and-exploration.mp4",
    "poster": "/use-case-films/travel-and-exploration.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/use-case-films/travel-and-exploration.vtt",
    "description": "A Jessica-narrated introduction to Gab AI for travel & exploration, featuring Trip Planner, Real-Time Research, Translator and an illustrative tool preview."
  },
  "churches": {
    "src": "/churches/ministry-film.mp4",
    "poster": "/churches/ministry-film.jpg",
    "duration": 25,
    "uploadDate": "2026-10-06T20:00:00Z",
    "narrated": true,
    "captions": "/churches/ministry-film.vtt",
    "description": "A narrated introduction to Gab AI for churches and ministries, its Christian and conservative in-house model, ministry tools, and organization plans."
  }
}
